<template>
  <v-card outlined rounded="lg" class="pa-4" elevation="0">
    <v-row class="ma-0" dense v-if="!isResult">
      <v-col cols="12">
        <v-autocomplete
          multiple
          v-model="filter.standardEquipment"
          @change="list"
          :items="standardEquipments"
          :disabled="isResult"
          item-text="name"
          return-object
          append-icon="mdi-chevron-down"
          :label="$t('Equipamentos padrão')"
          placeholder="Todas"
        ></v-autocomplete>
      </v-col>

      <v-col class="text-center" cols="12">
        <span>{{ $t('Período') }}</span>
        <div class="d-flex justify-center align-center mt-3">
          <v-menu
            ref="startDateMenu"
            :close-on-content-click="false"
            :return-value.sync="startDate"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                :disabled="isResult"
                append-icon="mdi-calendar"
                class="primary-button"
                style="text-transform: none"
                readonly
                v-bind="attrs"
                v-on="on"
              >
                {{ `${formatMonth(startDate)}` }}
              </v-btn>
            </template>
            <v-date-picker
              v-model="startDate"
              type="month"
              locale="pt-br"
              no-title
              scrollable
              @change="
                $refs.startDateMenu.save(startDate),
                  (filterProp.data = null),
                  list()
              "
            >
            </v-date-picker>
          </v-menu>

          <span class="mx-2">{{ $t('Até') }}</span>

          <v-menu
            ref="endDateMenu"
            :close-on-content-click="false"
            :return-value.sync="endDate"
            transition="scale-transition"
            @change="list"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                :disabled="isResult"
                append-icon="mdi-calendar"
                class="primary-button"
                style="text-transform: none"
                readonly
                v-bind="attrs"
                v-on="on"
              >
                {{ `${formatMonth(endDate)}` }}
              </v-btn>
            </template>
            <v-date-picker
              v-model="endDate"
              type="month"
              locale="pt-br"
              no-title
              scrollable
              @change="
                $refs.endDateMenu.save(endDate),
                  (filterProp.data = null),
                  list()
              "
            >
            </v-date-picker>
          </v-menu>
        </div>
      </v-col>
    </v-row>

    <v-alert
      type="warning"
      class="my-3 pa-1 text-center"
      v-if="productiveTimes.length == 0"
    >
      {{ $t('Nenhum dado encontrado') }}
    </v-alert>

    <div v-else>
      <v-row class="ma-0" justify="center">
        <v-col cols="12">
          <strong>Total: {{ total }}</strong>

          <div>
            <div class="hidden-md-and-up">
              <v-data-table
                :loading="loading"
                :headers="mobileHeader"
                :items="productiveTimes"
                class="main-table"
                :hide-default-footer="!filterProp.data"
                show-expand
                item-key="name"
                :single-expand="false"
                :items-per-page="7"
                :header-props="headerProps"
                :mobile-breakpoint="330"
                :expanded.sync="expanded"
                @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
              >
                <template v-slot:[`item.name`]="{ item }">
                  {{ item.userName }}
                </template>

                <template v-slot:[`item.totalTime`]="{ item }">
                  {{ item.totalTime }}
                </template>

                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>{{ $t('Qdte de Etapas') }}:</strong>
                        {{ item.quantityStep }}
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>{{ $t('Tempo Etapas') }}:</strong>
                        {{ item.stepTime }}
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>{{ $t('Qtde de Tarefas') }}:</strong>
                        {{ item.quantityTasks }}
                      </p>
                    </v-col>
                    <v-col class="ma-0 pa-0" cols="12">
                      <p>
                        <strong>{{ $t('Tempo Tarefas') }}:</strong>
                        {{ item.tasksTime }}
                      </p>
                    </v-col>
                  </td>
                </template>
              </v-data-table>
              <div class="pagination" v-if="!filterProp.data">
                <div class="item-pagination block-two">
                  <v-pagination
                    class="pagination-item"
                    v-model="page"
                    :length="totalPages"
                    :total-visible="3"
                  ></v-pagination>
                </div>
              </div>
            </div>

            <div class="hidden-md-and-down">
              <v-data-table
                :loading="loading"
                :headers="header"
                :items="productiveTimes"
                class="main-table"
                :hide-default-footer="!filterProp.data"
                hide-default-header
                :header-props="headerProps"
                :items-per-page="7"
                :mobile-breakpoint="0"
              >
                <template #header="{ props, on }">
                  <thead>
                    <tr>
                      <th
                        class="text-center"
                        v-for="header in props.headers"
                        :key="header.value"
                      >
                        <v-simple-checkbox
                          v-if="header.value === 'data-table-select'"
                          v-model="props.everyItem"
                          :indeterminate="props.someItems && !props.everyItem"
                          color="purple"
                          @input="on['toggle-select-all']"
                        ></v-simple-checkbox>

                        <div>
                          <v-hover v-slot="{ hover }">
                            <div>
                              <span>{{ $t(header.text) }}</span>
                              <v-icon
                                v-if="
                                  hover &&
                                  header.value != 'data-table-select' &&
                                  header.value != 'actions'
                                "
                                color="white"
                                class="mx-2"
                                @click="on.sort(header.value)"
                              >
                                {{
                                  props.options.sortBy.includes(header.value)
                                    ? `mdi-chevron-down`
                                    : `mdi-chevron-up`
                                }}
                              </v-icon>
                            </div>
                          </v-hover>
                        </div>
                      </th>
                    </tr>
                  </thead>
                </template>

                <template v-slot:[`item.name`]="{ item }">
                  {{ item.userName }}
                </template>

                <template v-slot:[`item.quantityStep`]="{ item }">
                  {{ item.quantityStep }}
                </template>

                <template v-slot:[`item.timeStep`]="{ item }">
                  {{ item.stepTime }}
                </template>

                <template v-slot:[`item.quantityTask`]="{ item }">
                  {{ item.quantityTasks }}
                </template>

                <template v-slot:[`item.timeTask`]="{ item }">
                  {{ item.tasksTime }}
                </template>

                <template v-slot:[`item.totalTime`]="{ item }">
                  {{ item.totalTime }}
                </template>
              </v-data-table>
              <div class="pagination" v-if="!filterProp.data">
                <div class="item-pagination block-two">
                  <v-pagination
                    class="pagination-item"
                    v-model="page"
                    :length="totalPages"
                    :total-visible="3"
                  ></v-pagination>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-row class="ma-0">
      <v-col cols="12" v-if="isResult">
        <strong>{{ $t('Análise crítica') }}</strong>
        <p v-html="review"></p>
      </v-col>
      <v-col cols="12" v-else>
        <tiptap-vuetify
          v-model="filter.review"
          :extensions="extensions"
          :label="$t('Análise crítica')"
          :placeholder="
            $t('Digite sua análise crítica para o indicador abaixo')
          "
          :card-props="{ flat: true, outlined: true, rounded: true }"
          class="primary-input"
          outlined
          dense
          hide-details="auto"
        ></tiptap-vuetify>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ApiService from '../../../../../../../../services/ApiService'
import Utils from '../../../../../../../../Utils/FormatDate'
import moment from 'moment'
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from 'tiptap-vuetify'

export default {
  props: {
    filterProp: Object,
    institution: Object,
    unidades: Array,
    standardEquipments: Array,
    isResult: { type: Boolean, default: false },
    review: String,
  },

  components: {
    TiptapVuetify,
  },

  data() {
    return {
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      filter: {
        page: 1,
        pageSize: 7,
        institutionId: null,
        unidadeIds: [],
        standardEquipment: [],
        startDate: null,
        endDate: null,
        review: '',
      },
      apiService: new ApiService(),
      loading: false,
      showChart: true,
      productiveTimes: [],
      expanded: [],
      page: 1,
      totalPages: 1,
      pageSize: 7,
      headerProps: {
        sortByText: 'Ordenar por',
      },
      header: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Nome',
          align: 'center',
          value: 'name',
        },
        {
          text: 'Qtd. Etapas',
          align: 'center',
          value: 'quantityStep',
        },
        {
          text: 'Tempo Etapas',
          align: 'center',
          value: 'timeStep',
        },
        {
          text: 'Qtd Tarefas',
          align: 'center',
          value: 'quantityTask',
        },
        {
          text: 'Tempo Tarefas',
          align: 'center',
          value: 'timeTask',
        },
        {
          text: 'Tempo Total',
          align: 'center',
          value: 'totalTime',
        },
      ],
      mobileHeader: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Nome',
          align: 'center',
          value: 'name',
        },
        {
          text: 'Tempo Total',
          align: 'center',
          value: 'totalTime',
        },
      ],
      total: 0,
      startDate: '',
      endDate: '',
    }
  },

  async created() {
    this.filter.institutionId = this.institution.id
    this.filter.unidadeIds = this.unidades

    this.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    if (this.filterProp) {
      this.filter = this.filterProp
      this.startDate = moment(this.filter.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.endDate = moment(this.filter.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    }

    this.list()
  },

  methods: {
    setDates() {
      this.filter.startDate = moment(this.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.filter.endDate = moment(this.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    },

    formatMonth(date) {
      return moment(date).locale(this.$i18n.locale).format('MMMM/YYYY')
    },

    setInfos() {
      const model = {
        chart: '2.11 - Tempo produtivo por setor',
        ...this.filter,
        data: null,
      }
      this.$emit('setInfos', model)
    },

    async list() {
      if (this.filterProp.data) {
        const response = JSON.parse(this.filterProp.data)
        this.total = response.content.total
        this.productiveTimes = response.content.paged.objects
        this.totalPages = response.content.paged.pager.totalPages
        return
      }

      this.setDates()
      this.loading = true
      this.filter.institutionId = this.institution.id
      this.filter.pageSize = 7
      this.filter.unidadeIds = this.unidades
      await this.apiService
        .post('reports/productiveTimeSector', this.filter)
        .then((response) => {
          this.total = response.content.total
          this.productiveTimes = response.content.paged.objects
          this.totalPages = response.content.paged.pager.totalPages
        })
        .catch((err) => {})
      this.loading = false
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },
  },
  watch: {
    page() {
      this.filter.page = this.page
      this.list()
    },

    filter: {
      deep: true,
      handler() {
        this.setInfos()
      },
    },
  },
}
</script>
